import React, { useEffect, useState } from "react";
import { RootStateOrAny } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../index";
import {
  fetchCurrenciesDic,
  fetchDicRoutingOrdersStatuses,
} from "../../store/slices/rtkDictionaries";
import { fetchOfferList } from "../../store/slices/offering/offering";
import loadingStatusCodes from "../../lib/const/loadingStatusCodes";
import { RoutingOrders } from "../../components/RoutingOrders/RoutingOrders";
import { fetchDestinationCategories } from "../../store/slices/dicts";
import { fetchAgreements } from "../../store/slices/routingOrders/routingOrders";
import { AnyObject } from "../../lib/interfaces";

export const RoutingOrdersContainer = () => {
  const dispatch = useAppDispatch();
  const {
    dicCurrencies,
    dicCurrenciesLoading,
    dicRoutingOrdersStatuses,
    dicRoutingOrdersStatusesLoading,
  } = useAppSelector((state) => state.rtkDictionaries);
  const { destinationCategories, destinationCategoriesLoading } = useAppSelector(
    (state) => state.dicts
  );
  // const { offerList, offerListLoading } = useAppSelector((state) => state.offering);
  const { tenantProperties, tenantPropertiesLoading } = useAppSelector(
    (state: RootStateOrAny) => state?.tenants
  );

  const [offerList, setOfferList] = useState<AnyObject | undefined>(undefined);

  useEffect(() => {
    dispatch(fetchCurrenciesDic());
    dispatch(fetchDicRoutingOrdersStatuses());
    dispatch(fetchDestinationCategories());
  }, []);

  useEffect(() => {
    if (tenantPropertiesLoading === loadingStatusCodes.fulfilled) {
      dispatch(fetchAgreements(tenantProperties.accountId)).then((response) => {
        dispatch(fetchOfferList({ agreementId: response.payload[0]?.id })).then((response) => {
          if (Array.isArray(response.payload?.content)) {
            setOfferList(response.payload.content);
          }
        });
      });
    }
  }, [tenantPropertiesLoading, tenantProperties]);

  return (
    <>
      {dicCurrenciesLoading === loadingStatusCodes.fulfilled &&
        dicRoutingOrdersStatusesLoading === loadingStatusCodes.fulfilled &&
        destinationCategoriesLoading === loadingStatusCodes.fulfilled &&
        offerList && (
          <RoutingOrders
            dicCurrencies={dicCurrencies}
            offerList={offerList}
            dicRoutingOrdersStatuses={dicRoutingOrdersStatuses}
            destinationCategories={destinationCategories}
          />
        )}
    </>
  );
};
